<div class="full-width">
  <mat-accordion multi>
    <ng-container *ngFor="let step of visibleSteps; trackBy: trackByStepId">
      <div class="row no-gutters">
        <div class="d-flex full-width">
          <checklist-step
            class="full-width"
            [disabled]="disabled"
            [currentChecklist]="currentChecklist"
            [currentChecklistTemplate]="currentChecklistTemplate"
            [step]="step"
            [precheck]="precheck ?? false"
            (checkShared)="checkShared.emit($event)"
            (taskChanged)="taskChanged.emit($event)"
            (viewportChanged)="viewportChanged.emit()"
          ></checklist-step>
        </div>
      </div>
    </ng-container>
  </mat-accordion>
</div>
